import React from 'react';
import AppRouter from './appRouter';
import './app.scss';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;